import { Link } from 'gatsby';
import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Button from '../components/Button';
import Card from '../components/Card';
import ContactButton from '../components/ContactButton';
import LabelText from '../components/LabelText';
import Layout from '../components/layout/Layout';
import ProjectGrid from '../components/ProjectGrid';
import SplitSection from '../components/SplitSection';
import StatsBox from '../components/StatsBox';
import SvgApp from '../svg/SvgApp';
import SvgAudio from '../svg/SvgAudio';
import SvgHero from '../svg/SvgHero';
import SvgServer from '../svg/SvgServer';
import SvgVideo from '../svg/SvgVideo';
import SvgWebsite from '../svg/SvgWebsite';

export default ({ location }) => (
  <Layout location={location}>
    <section className="pt-20 md:pt-40">
      <div className="container mx-auto px-8 lg:flex">
        <div className="text-center lg:text-left lg:w-1/2">
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-none">
            We are a full-service creative studio based in Barcelona
          </h1>
          <p className="text-xl lg:text-2xl mt-6 font-light">
            We transform brands, grow businesses & tell stories that deepen engagement through
            thoughtful design
          </p>
          <p className="mt-8 md:mt-12">
            <ContactButton size="lg">Contact</ContactButton>
          </p>
          <p className="mt-4 text-gray-600">Ask for a quote of your project</p>
        </div>
        <div className="lg:w-1/2">
          <SvgHero />
        </div>
      </div>
    </section>

    <section id="stats" className="py-20 lg:pt-32">
      <div className="container mx-auto text-center">
        <LabelText className="text-gray-600">Our customers get results</LabelText>
        <div className="flex flex-col sm:flex-row mt-8 lg:px-24">
          <div className="w-full sm:w-1/3">
            <StatsBox
              number={new Date().getFullYear() - 2011}
              secondaryText="Years of Experience"
              duration={1.5}
            />
          </div>
          <div className="w-full sm:w-1/3">
            <StatsBox number={100371} secondaryText="Lines of code written" duration={2} />
          </div>
          <div className="w-full sm:w-1/3">
            <StatsBox number={100} suffix="%" secondaryText="Customer Satisfaction" duration={4} />
          </div>
        </div>
      </div>
    </section>

    <section id="services" className="py-20 lg:pb-40 lg:pt-48">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl lg:text-5xl font-semibold">Services</h2>
        <div className="flex flex-col sm:flex-row sm:-mx-3 mt-12">
          <div className="flex-1 px-3">
            <AnchorLink href="#website-creation">
              <Card className="mb-8">
                <p className="font-semibold text-xl">Website Creation</p>
              </Card>
            </AnchorLink>
          </div>
          <div className="flex-1 px-3">
            <AnchorLink href="#mobile-app">
              <Card className="mb-8">
                <p className="font-semibold text-xl">Mobile App Development</p>
              </Card>
            </AnchorLink>
          </div>
          <div className="flex-1 px-3">
            <AnchorLink href="#it-solutions">
              <Card className="mb-8">
                <p className="font-semibold text-xl">IT &amp; Cloud Solutions</p>
              </Card>
            </AnchorLink>
          </div>
        </div>
      </div>
      <SplitSection
        id="website-creation"
        primarySlot={
          <div className="lg:pr-32 xl:pr-48">
            <h3 className="text-3xl font-semibold leading-tight">Website Creation</h3>
            <p className="mt-8 text-xl font-light leading-relaxed">
              Our team of enthusiastic web developers will evaluate your requirements and build the
              best income generating website for your brand.
            </p>
            <Link to="/projects?filters=web">
              <Button size="lg" className="mt-8">
                See our Websites
              </Button>
            </Link>
          </div>
        }
        secondarySlot={<SvgWebsite />}
      />
      <SplitSection
        id="mobile-app"
        reverseOrder
        primarySlot={
          <div className="lg:pl-32 xl:pl-48">
            <h3 className="text-3xl font-semibold leading-tight">Mobile App Development</h3>
            <p className="mt-8 text-xl font-light leading-relaxed">
              Let our staff handle the heavy lifting involved in developing and launching an
              iOS/Android app. Just sit down and enjoy watching it as is being built!
            </p>
            <Link to="/projects?filters=app">
              <Button size="lg" className="mt-8">
                See our Mobile Apps
              </Button>
            </Link>
          </div>
        }
        secondarySlot={<SvgApp />}
      />
      <SplitSection
        id="it-solutions"
        primarySlot={
          <div className="lg:pr-32 xl:pr-48">
            <h3 className="text-3xl font-semibold leading-tight">IT &amp; Cloud Solutions</h3>
            <p className="mt-8 text-xl font-light leading-relaxed">
              Our team of software engineers will build a cloud solution specifically adapted to
              your needs.
            </p>
            <Link to="/projects?filters=it">
              <Button size="lg" className="mt-8">
                See our IT &amp; Cloud Solutions
              </Button>
            </Link>
          </div>
        }
        secondarySlot={<SvgServer />}
      />
      <SplitSection
        id="videos"
        reverseOrder
        primarySlot={
          <div className="lg:pl-32 xl:pl-48">
            <h3 className="text-3xl font-semibold leading-tight">Video</h3>
            <p className="mt-8 text-xl font-light leading-relaxed">lorem ipsum....</p>
            <Link to="/projects?filters=video">
              <Button size="lg" className="mt-8">
                See our Videos
              </Button>
            </Link>
          </div>
        }
        secondarySlot={<SvgVideo />}
      />
      <SplitSection
        id="it-solutions"
        primarySlot={
          <div className="lg:pr-32 xl:pr-48">
            <h3 className="text-3xl font-semibold leading-tight">Audio</h3>
            <p className="mt-8 text-xl font-light leading-relaxed">Lorem ipsum...</p>
            <Link to="/projects?filters=audio">
              <Button size="lg" className="mt-8">
                See our IT &amp; Cloud Solutions
              </Button>
            </Link>
          </div>
        }
        secondarySlot={<SvgAudio />}
      />
    </section>

    <section id="projects" className="py-20 lg:py-40">
      <LabelText className="mb-8 text-gray-600 text-center">SOME OF OUR PROJECTS</LabelText>
      <ProjectGrid />
      <div className="container mx-auto text-center">
        <Link to="/projects">
          <Button size="lg" className="mt-8 mx-auto">
            See more projects
          </Button>
        </Link>
      </div>
    </section>

    <section className="container mx-auto my-20 py-24 bg-gray-200 rounded-lg text-center">
      <h3 className="text-5xl font-semibold">Ready to grow your business?</h3>
      <p className="mt-8 text-xl font-light">Get a quote for your project without obligation</p>
      <p className="mt-8">
        <ContactButton size="xl">Contact</ContactButton>
      </p>
    </section>
  </Layout>
);
